import { SpinLoader } from 'app/components';
import * as React from 'react';
import { useEffect } from 'react';
import { useActionCreators } from 'app/area/favourite/hooks';

interface CreateDashboardFavouriteRouteProps {
  router: { location: { query: { report: string }}};
  params: {
    favouriteId: number;
  };
}

export function CreateDashboardFavouriteRoute({
  params
}: CreateDashboardFavouriteRouteProps) {

  const {
    loadDashboardFavouriteDefinition
  } = useActionCreators();

  useEffect(() => {
    loadDashboardFavouriteDefinition(params);
  }, []);

  return <SpinLoader />;
}
